<template>
  <div class="breadcrumbs bar">
        <span class="breadcrumb" v-on:click="state.breadcrumb.splice(0); state.editing = false;">Home</span>
        <span v-for="(bc, idx) in state.breadcrumb" v-bind:key="idx" class="breadcrumb" v-bind:class="{current: idx == state.breadcrumb.length-1}">
          <ErranditeIcon v-if="idx != state.breadcrumb.length-1" icon="chevron-right"/>
          <span v-if="idx != state.breadcrumb.length-1" class="breadcrumb" v-on:click="state.breadcrumb.splice(idx + 1); state.editing = false;">{{ data.tasks[bc].label }}</span>
        </span>
    </div>
</template>

<script>

import ErranditeIcon from './ErranditeIcon.vue'

export default {
  name: 'ErranditeBreadcrumb',
  props: {
    state: Object,
    data: Object
  },
  components: {
      ErranditeIcon
  }
}
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style lang="scss">
@import "../styles/_variables.scss";



</style>
